import { Component, OnInit, Input, NgZone, ViewChild, ElementRef } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { Venue } from '../../models/venue';
import { VenueService } from '../../services/venue.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MapsAPILoader } from '@agm/core';
import { } from 'googlemaps';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {
  publicating: boolean = false;
  venue: Venue;
  location: any;
  zoom: number = 2;
  addresses : any;
  placeSelected: boolean = false;
  @Input() venue_id;
  @Input() venue_name;
  @Input() venue_lat;
  @Input() venue_lng;
  @Input() venue_address;
  @Input() sendData;

  @ViewChild("address") public searchElementRef: ElementRef;

  constructor(public dialogRef: MdDialogRef<MapComponent>,
              private venueService: VenueService,
              private dialog: MdDialog,
              private _ngZone: NgZone,
              private mapsAPILoader: MapsAPILoader) { }

  ngOnInit() {
    this.venue = {
      id: '',
      name: '',
      lat: 4.6482837,
      lng: -74.2478961,
      address: '',
      address_components: {},
    };

    if (this.venue_id) {
      this.venue.id = this.venue_id;
      this.venue.name = this.venue_name;
      this.venue.lat = parseFloat (this.venue_lat);
      this.venue.lng = parseFloat (this.venue_lng);
      this.venue.address = this.venue_address;
      this.placeSelected = true;
    }

    if (this.sendData) {
      this.zoom = 17;
    } else {
      this.zoom = 2;
    }

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"]
      });
      autocomplete.addListener("place_changed", () => {
        this.zoom = 17;
        this.placeSelected = false;

        this._ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.setAddress(place);
        });
      });
    });
  }

  markerDragEnd(event: any) {
    this.venue.lat = event.coords.lat;
    this.venue.lng = event.coords.lng;
  }

  _keyPressNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  _keyPressLetter(event: any) {
    const pattern = /^[a-zA-Z]+$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  onPostVenue() {
    this.publicating = true;

    this.venueService.postVenues(this.venue)
      .subscribe(
        data => {
          this.dialogRef.close(data);
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: 'Sede Creada', success: true, showIcon:true}});
        },
        error => {
          console.log(error);
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {title: 'No se pudo crear la Sede', message: 'Verifique los datos de Nombre y Dirección de la sede', alert: true, showIcon:true}});
        }
      );
  }

  onPutVenue() {
    this.publicating = true;

    this.venueService.putVenues(this.venue)
      .subscribe(
        data => {
          this.dialogRef.close(this.venue);
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: 'Sede Actualizada', showIcon:true}});
        },
        error => {
          console.log(error);
          this.publicating = false;
        }
      );
  }

  onDeleteVenue() {
    this.publicating = true;

    this.venueService.deleteVenues(this.venue.id)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: 'Sede Eliminada', showIcon:true}});
          this.venue.id = null;
          this.dialogRef.close(this.venue);
        },
        error => {
          console.log(error);
          this.publicating = false;
        }
      );
  }

  //noinspection JSMethodCanBeStatic
  private parsePlace(place: Object) {
    let venueInfo = {};

    if(place['address_components']) {
      for (let address of place['address_components']) {

        // check if the component has at least one type
        if(!address['types'] || address['types'].length == 0) {
          continue;
        }

        const type = address['types'][0];
        venueInfo[type] = {
          long_name: address.long_name,
          short_name: address.short_name
        }
      }
    }

    return venueInfo;
  }

  setAddress(place:Object) {
    this._ngZone.run(() => {
      try {
        this.addresses = place['formatted_address'];
        let location = place['geometry']['location'];
        this.venue.address_components = this.parsePlace(place);
        this.venue.lat =  location.lat();
        this.venue.lng = location.lng();
        this.venue.address = this.addresses;
        this.placeSelected = true;
      } catch (e) {
        console.log("error:", e)
      }
    });
  }

  isValidVenue() {
    return !!(this.venue.name && this.venue.address && this.placeSelected);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/map/map.component.ts